import { Box, Button, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { addQuestions, getAllQuestions, updateQuestion } from './QuestionsRequests'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import { blue, green } from '@mui/material/colors';
import Modal from '@mui/material/Modal';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import CloseIcon from '@mui/icons-material/Close';
import Swal from 'sweetalert2';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    //   border: '2px solid #000',
    borderRadius:5,
    boxShadow: 24,
    p: 4,
};
export const Questions = () => {
    const [questions,setQuestions] = useState([])
    const [difficulty,setDifficulty] = useState(['Easy','Intermediate','Hard'])
    const [newQuestion,setNewQuestion] = useState({
        name:'',
        choices:[{name:'',key:''}],
        answer:'',
        difficulty:'Easy',
        points:1
    })
    useEffect(()=>{
        _init();
    },[])
    const _init = async () => {
        const res = await getAllQuestions()
        console.log(res.data)
        res.data.data.forEach(el=>{
            el.show_ans = false;
            el.editable = false;
        })
        setQuestions(res.data.data)
    }
    const handleShowAns = (item) => {
        let temp = [...questions]
        let key = temp.findIndex(el=>el.id === item.id);
        temp[key].show_ans = true;
        setQuestions(temp)
    }
    const handleHideAns = (item) => {
        let temp = [...questions]
        let key = temp.findIndex(el=>el.id === item.id);
        temp[key].show_ans = false;
        setQuestions(temp)
    }
    const [openAddModal, setOpenAddModal] = useState(false);
    const handleOpenAddModal = () => setOpenAddModal(true);
    const handleCloseAddModal = () => setOpenAddModal(false);
    const handleAddChoices = () => {
        let temp = {...newQuestion};
        temp.choices.push({
            name:'',
            key:''
        })
        setNewQuestion(temp)
    }
    const handleRemoveItem = (index) => {
        let temp = {...newQuestion};
        temp.choices.splice(index,1);
        setNewQuestion(temp)
    }
    const handleChangeEditChoices = (name,val,index) => {
        let temp = {...newQuestion};
        temp.choices[index][name] = val.target.value;
        setNewQuestion(temp)
    }
    const handleChangeUpdateChoices = (name,val,index) => {
        let temp = {...editableData};
        let c = JSON.parse(temp.choices);
        c[index][name] = val.target.value;
        temp.choices = JSON.stringify(c)
        setEditableData(temp)
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(newQuestion)
        try{
            const res = await addQuestions(newQuestion)
            if(res.data.status === 200){
                setQuestions(res.data.data)
                setNewQuestion({
                    name:'',
                    choices:[{name:'',key:''}],
                    answer:'',
                    difficulty:newQuestion.difficulty,
                    points:newQuestion.points,
                })
                Swal.fire({
                    icon:'success',
                    title:res.data.message,
                    timer:1500
                })
            }else{
                Swal.fire({
                    icon:'error',
                    title:res.data.message
                })
            }
        }catch(err){
            Swal.fire({
                icon:'error',
                title:err
            })
        }
    }
    const handleChange = (name,val,index) => {
        let temp = {...newQuestion};
        temp.choices[index][name] = val.target.value;
        setNewQuestion(temp)
    }
    const [editableData,setEditableData] = useState({
    })

    const handleEdit = (item) => {
        let temp = [...questions];
        let index = temp.findIndex(el=> el.id === item.id)
        temp[index].editable = true;
        setQuestions(temp)
        setEditableData(item)
    }
    const handleCancel = (item) => {
        let temp = [...questions];
        let index = temp.findIndex(el=> el.id === item.id)
        temp[index].editable = false;
        setQuestions(temp)
    }
    const handleChangeEdit = (name,val,index) => {
        let temp = {...questions};
        temp.choices[index][name] = val.target.value;
        setQuestions(temp)
    }
    const handleSaveUpdate = async () => {
        try{
            Swal.fire({
                icon:'info',
                title:'Saving update',
                text:'Please wait...',
                showConfirmButton:false,
                allowOutsideClick:false,
                allowEscapeKey:false
            })
            Swal.showLoading();
            const res = await updateQuestion(editableData)
            if(res.data.status === 200){
                let temp = [...questions];
                let index = temp.findIndex(el=> el.id === editableData.id)
                temp[index].editable = false;
                setQuestions(temp)
                setQuestions(res.data.data)
                Swal.fire({
                    icon:'success',
                    title:res.data.message
                })
            }else{
                setQuestions(res.data.data)
                Swal.fire({
                    icon:'error',
                    title:res.data.message
                })
            }
        }catch(err){
            Swal.fire({
                icon:'error',
                title:err
            })
        }
        console.log(editableData)
    }
    const handleAddUpdateChoices = () => {
        let temp = {...editableData};
        let c = JSON.parse(temp.choices);
        c.push({
            key:'',
            name:''
        })
        temp.choices = JSON.stringify(c);
        setEditableData(temp)
    }
    const handleDeleteUpdateChoices = (index) => {
        let temp = {...editableData};
        let c = JSON.parse(temp.choices);
        c.splice(index,1)
        temp.choices = JSON.stringify(c);
        setEditableData(temp)
    }
    return (
        <Grid container spacing={1} sx={{p:1,background:'#f1f1f1'}}>
            <Grid item xs={12}>
                <Button variant='contained' onClick={handleOpenAddModal}>Add Question</Button>
            </Grid>
                {
                    questions.map((item)=>{
                        return (
                            <Grid item xs={12} sm={3} lg={3}>
                            
                            <Paper>
                                <Box sx={{p:1,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                                    <Typography>Question #{item.sort}</Typography>
                                    {
                                    item.editable
                                    ?
                                    <Box sx={{display:'flex',justifyContent:'flex-end',gap:1}}>
                                    <Tooltip title='Save'>
                                    <IconButton color='primary' onClick={handleSaveUpdate}><SaveAltIcon/></IconButton>
                                    </Tooltip>
                                    <Tooltip title='Cancel'>
                                    <IconButton color='error' onClick={()=>handleCancel(item)}><CloseIcon/></IconButton>
                                    </Tooltip>
                                    </Box>
                                    :
                                    <Box sx={{display:'flex',justifyContent:'flex-end',gap:1}}>
                                    <Tooltip title='Update'>
                                    <IconButton color='success' onClick={()=>handleEdit(item)}><EditIcon/></IconButton>
                                    </Tooltip>
                                    <Tooltip title='Delete'>
                                    <IconButton color='error'><DeleteIcon/></IconButton>
                                    </Tooltip>
                                    </Box>
                                }
                                    </Box>
                                
                                    {
                                        item.editable
                                        ?
                                        <Box sx={{display:'flex',gap:1,p:1}}>
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">Difficulty</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                label="Difficulty"
                                                value={editableData.difficulty}
                                                onChange={(val)=>setEditableData({...editableData,difficulty:val.target.value})}
                                                required
                                            >
                                                {
                                                    difficulty.map((item)=>{
                                                        return (
                                                            <MenuItem value={item}>{item}</MenuItem>
                                                        )
                                                    })
                                                }
                                            </Select>
                                            </FormControl>
                                            <TextField label='Point/s' value={editableData.point} onChange={(val)=>setEditableData({...editableData,point:val.target.value})} fullWidth required/>
                                        </Box>
                                        :
                                        <Box sx={{display:'flex',justifyContent:'space-between',p:1,background:blue[900],color:'#fff'}}>
                                        <Typography>{item.difficulty}</Typography>
                                        <Typography>{item.point} {item.point>1?'points':'point'}</Typography>
                                        </Box>

                                    }
                                    
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell> 
                                                    {
                                                        item.editable
                                                        ?
                                                        <TextField label='Question' value={editableData.question} onChange={(val)=>setEditableData({...editableData,question:val.target.value})} fullWidth multiline rows={4}/>
                                                        :
                                                        <Typography variant='h6'>{item.question}</Typography>
                                                    }

                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                item.editable
                                                ?
                                                JSON.parse(editableData.choices).map((item2,key2)=>{
                                                    return(
                                                        <TableRow>
                                                            <TableCell>
                                                                <Box sx={{display:'flex',flexDirection:'row',gap:1}}>
                                                                    <TextField size='small' label='KEY' value={item2.key} onChange={(val)=>handleChangeUpdateChoices('key',val,key2)}/>
                                                                    <TextField size='small' value={item2.name} onChange={(val)=>handleChangeUpdateChoices('name',val,key2)} fullWidth/>
                                                                    <IconButton color='error' onClick={()=>handleDeleteUpdateChoices(key2)}><DeleteIcon/></IconButton>
                                                                    {
                                                                        JSON.parse(editableData.choices).length===key2+1
                                                                        ?
                                                                        <Tooltip title='Add Choice'>
                                                                        <IconButton sx={{float:'right'}} color='success' onClick={handleAddUpdateChoices}><AddIcon/></IconButton>
                                                                        </Tooltip>
                                                                        :
                                                                        null
                                                                    }
                                                                </Box>
                                                            </TableCell>

                                                        </TableRow>
                                                    )
                                                })
                                                :
                                                JSON.parse(item.choices).map((item2,key2)=>{
                                                    return (
                                                        <TableRow>
                                                            <TableCell>
                                                                <strong>{item2.key}.</strong> {item2.name}
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                })
                                            }
                                            {
                                                item.editable
                                                ?
                                                <TableRow>
                                                    <TableCell>
                                                            <TextField label='Correct Answer' value={editableData.answer} onChange={(val)=>setEditableData({...editableData,answer:val.target.value.toUpperCase()})} fullWidth required/>
                                                    </TableCell>
                                                </TableRow>
                                                :
                                                <TableRow>
                                                    <TableCell>
                                                            {
                                                                item.show_ans
                                                                ?
                                                                <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                                                                    <Typography sx={{fontSize:'1.1rem',fontWeight:'bold',color:green[500]}}>{item.answer}</Typography>
                                                                    <Tooltip title = 'Hide Answer'>
                                                                    <IconButton onClick={()=>handleHideAns(item)}><VisibilityOffIcon/></IconButton>
                                                                    </Tooltip>
                                                                </Box>
                                                                :
                                                                <Box sx={{display:'flex',justifyContent:'flex-end'}}>
                                                                <Tooltip title = 'Show Answer'>
                                                                <IconButton onClick={()=>handleShowAns(item)}><VisibilityIcon/></IconButton>
                                                                </Tooltip>
                                                                </Box>


                                                            }
                                                    </TableCell>
                                                </TableRow>
                                            }
                                            
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                            </Grid>
                        )
                    })
                    
                }
                <Modal
                    open={openAddModal}
                    onClose={handleCloseAddModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Adding New Question
                    </Typography>
                    <form onSubmit={handleSubmit}>
                    <Grid container sx={{pt:2}} spacing={1}>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Difficulty</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Difficulty"
                                value={newQuestion.difficulty}
                                onChange={(val)=>setNewQuestion({...newQuestion,
                                    difficulty:val.target.value
                                })}
                            >
                                {
                                    difficulty.map((item)=>{
                                        return (
                                            <MenuItem value={item}>{item}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField label='Point/s' type='number' value={newQuestion.points} onChange={(val)=>setNewQuestion({...newQuestion,
                                points:val.target.value
                            })} fullWidth/>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField label='Question' value={newQuestion.name} onChange={(val)=>setNewQuestion({...newQuestion,
                                name:val.target.value
                            })} fullWidth required/>
                        </Grid>
                        <Grid item xs={12} sx={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                            <Typography>Choices:</Typography>
                            <IconButton color='success' onClick={handleAddChoices}><AddIcon/></IconButton>
                        </Grid>
                        <Grid item xs={12} sx={{display:'flex',flexDirection:'column',gap:1,maxHeight:'30vh',overflow:'auto'}}>
                            {
                                newQuestion.choices.map((item,key)=>{
                                    return (
                                        <Box sx={{display:'flex',gap:1,alignItems:'center'}}>
                                        <TextField sx={{textTransform:'uppercase'}} label='Key' value={item.key} onChange={(val)=>handleChange('key',val,key)} required/>
                                        <TextField label='' value={item.name} onChange={(val)=>handleChange('name',val,key)} fullWidth required/>
                                        <IconButton color='error' onClick={()=>handleRemoveItem(key)}><DeleteIcon/></IconButton>
                                        </Box>
                                    )
                                })
                            }
                        </Grid>
                        <Grid item xs={12}>
                            <TextField label = 'Correct Answer' value={newQuestion.answer} onChange={(val)=>setNewQuestion({...newQuestion,
                                answer:val.target.value
                            })} fullWidth required/>
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant='contained' color='success' type='submit' fullWidth>Save</Button>
                        </Grid>
                    </Grid>
                    </form>
                    </Box>
                </Modal>
        </Grid>
    )
}